import styled from '@emotion/styled'

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 0.7em;
  margin-right: -0.7em;
`
